<template>
  <div class="PO-slide view-slide">
    <img src="../../assets/images/PO-bg.png">
    <div class="slide-text-part">
      <h3 v-on:click="select($event)">Portofoli Optmizer</h3>
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
      <div class="text-center">
        <button>OPEN APP</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "PortofolioComponent"
};
</script>

